/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as TeamRouteImport } from './routes/team'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as PricingRouteImport } from './routes/pricing'
import { Route as LearnRouteImport } from './routes/learn'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as CookiePolicyRouteImport } from './routes/cookie-policy'
import { Route as Contact2RouteImport } from './routes/contact-2'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as IndustriesIndexRouteImport } from './routes/industries/index'
import { Route as CompareIndexRouteImport } from './routes/compare/index'
import { Route as ServicesSupportRouteImport } from './routes/services.support'
import { Route as ServicesIntegrationRouteImport } from './routes/services.integration'
import { Route as ServicesImplementationRouteImport } from './routes/services.implementation'
import { Route as ServicesAdvisoryRouteImport } from './routes/services.advisory'
import { Route as PlatformXdrRouteImport } from './routes/platform.xdr'
import { Route as PlatformServiceDeskRouteImport } from './routes/platform.service-desk'
import { Route as PlatformResilienceRouteImport } from './routes/platform.resilience'
import { Route as PlatformPentestRouteImport } from './routes/platform.pentest'
import { Route as PlatformIamRouteImport } from './routes/platform.iam'
import { Route as PlatformGrcRouteImport } from './routes/platform.grc'
import { Route as PlatformDocumentsRouteImport } from './routes/platform.documents'
import { Route as PlatformCmdbRouteImport } from './routes/platform.cmdb'
import { Route as PlatformBusinessRouteImport } from './routes/platform.business'
import { Route as PlatformAiAgentsRouteImport } from './routes/platform.ai-agents'
import { Route as IndustriesRetailRouteImport } from './routes/industries/retail'
import { Route as IndustriesMsspRouteImport } from './routes/industries/mssp'
import { Route as IndustriesManufacturingRouteImport } from './routes/industries/manufacturing'
import { Route as IndustriesHealthcareRouteImport } from './routes/industries/healthcare'
import { Route as IndustriesGovernmentRouteImport } from './routes/industries/government'
import { Route as IndustriesFinancialRouteImport } from './routes/industries/financial'
import { Route as IndustriesEducationRouteImport } from './routes/industries/education'
import { Route as IndexHomeRouteImport } from './routes/index.home'
import { Route as CompareSplunkRouteImport } from './routes/compare/splunk'
import { Route as CompareServicenowRouteImport } from './routes/compare/servicenow'
import { Route as CompareSailpointRouteImport } from './routes/compare/sailpoint'
import { Route as CompareQualysRouteImport } from './routes/compare/qualys'
import { Route as CompareCrowdstrikeRouteImport } from './routes/compare/crowdstrike'
import { Route as CompareArcherRouteImport } from './routes/compare/archer'

const AuthLogoutLazyRouteImport = createFileRoute('/auth/logout')()
const AuthLoginLazyRouteImport = createFileRoute('/auth/login')()

const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
  id: '/terms-of-service',
  path: '/terms-of-service',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamRoute = TeamRouteImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const PricingRoute = PricingRouteImport.update({
  id: '/pricing',
  path: '/pricing',
  getParentRoute: () => rootRouteImport,
} as any)
const LearnRoute = LearnRouteImport.update({
  id: '/learn',
  path: '/learn',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const CookiePolicyRoute = CookiePolicyRouteImport.update({
  id: '/cookie-policy',
  path: '/cookie-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const Contact2Route = Contact2RouteImport.update({
  id: '/contact-2',
  path: '/contact-2',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const IndustriesIndexRoute = IndustriesIndexRouteImport.update({
  id: '/industries/',
  path: '/industries/',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareIndexRoute = CompareIndexRouteImport.update({
  id: '/compare/',
  path: '/compare/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLogoutLazyRoute = AuthLogoutLazyRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.logout.lazy').then((d) => d.Route))
const AuthLoginLazyRoute = AuthLoginLazyRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/auth.login.lazy').then((d) => d.Route))
const ServicesSupportRoute = ServicesSupportRouteImport.update({
  id: '/services/support',
  path: '/services/support',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/services.support.lazy').then((d) => d.Route),
)
const ServicesIntegrationRoute = ServicesIntegrationRouteImport.update({
  id: '/services/integration',
  path: '/services/integration',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/services.integration.lazy').then((d) => d.Route),
)
const ServicesImplementationRoute = ServicesImplementationRouteImport.update({
  id: '/services/implementation',
  path: '/services/implementation',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/services.implementation.lazy').then((d) => d.Route),
)
const ServicesAdvisoryRoute = ServicesAdvisoryRouteImport.update({
  id: '/services/advisory',
  path: '/services/advisory',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/services.advisory.lazy').then((d) => d.Route),
)
const PlatformXdrRoute = PlatformXdrRouteImport.update({
  id: '/platform/xdr',
  path: '/platform/xdr',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/platform.xdr.lazy').then((d) => d.Route))
const PlatformServiceDeskRoute = PlatformServiceDeskRouteImport.update({
  id: '/platform/service-desk',
  path: '/platform/service-desk',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/platform.service-desk.lazy').then((d) => d.Route),
)
const PlatformResilienceRoute = PlatformResilienceRouteImport.update({
  id: '/platform/resilience',
  path: '/platform/resilience',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/platform.resilience.lazy').then((d) => d.Route),
)
const PlatformPentestRoute = PlatformPentestRouteImport.update({
  id: '/platform/pentest',
  path: '/platform/pentest',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/platform.pentest.lazy').then((d) => d.Route),
)
const PlatformIamRoute = PlatformIamRouteImport.update({
  id: '/platform/iam',
  path: '/platform/iam',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/platform.iam.lazy').then((d) => d.Route))
const PlatformGrcRoute = PlatformGrcRouteImport.update({
  id: '/platform/grc',
  path: '/platform/grc',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/platform.grc.lazy').then((d) => d.Route))
const PlatformDocumentsRoute = PlatformDocumentsRouteImport.update({
  id: '/platform/documents',
  path: '/platform/documents',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/platform.documents.lazy').then((d) => d.Route),
)
const PlatformCmdbRoute = PlatformCmdbRouteImport.update({
  id: '/platform/cmdb',
  path: '/platform/cmdb',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/platform.cmdb.lazy').then((d) => d.Route))
const PlatformBusinessRoute = PlatformBusinessRouteImport.update({
  id: '/platform/business',
  path: '/platform/business',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/platform.business.lazy').then((d) => d.Route),
)
const PlatformAiAgentsRoute = PlatformAiAgentsRouteImport.update({
  id: '/platform/ai-agents',
  path: '/platform/ai-agents',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/platform.ai-agents.lazy').then((d) => d.Route),
)
const IndustriesRetailRoute = IndustriesRetailRouteImport.update({
  id: '/industries/retail',
  path: '/industries/retail',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/industries/retail.lazy').then((d) => d.Route),
)
const IndustriesMsspRoute = IndustriesMsspRouteImport.update({
  id: '/industries/mssp',
  path: '/industries/mssp',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/industries/mssp.lazy').then((d) => d.Route),
)
const IndustriesManufacturingRoute = IndustriesManufacturingRouteImport.update({
  id: '/industries/manufacturing',
  path: '/industries/manufacturing',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/industries/manufacturing.lazy').then((d) => d.Route),
)
const IndustriesHealthcareRoute = IndustriesHealthcareRouteImport.update({
  id: '/industries/healthcare',
  path: '/industries/healthcare',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/industries/healthcare.lazy').then((d) => d.Route),
)
const IndustriesGovernmentRoute = IndustriesGovernmentRouteImport.update({
  id: '/industries/government',
  path: '/industries/government',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/industries/government.lazy').then((d) => d.Route),
)
const IndustriesFinancialRoute = IndustriesFinancialRouteImport.update({
  id: '/industries/financial',
  path: '/industries/financial',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/industries/financial.lazy').then((d) => d.Route),
)
const IndustriesEducationRoute = IndustriesEducationRouteImport.update({
  id: '/industries/education',
  path: '/industries/education',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/industries/education.lazy').then((d) => d.Route),
)
const IndexHomeRoute = IndexHomeRouteImport.update({
  id: '/index/home',
  path: '/index/home',
  getParentRoute: () => rootRouteImport,
} as any)
const CompareSplunkRoute = CompareSplunkRouteImport.update({
  id: '/compare/splunk',
  path: '/compare/splunk',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/compare/splunk.lazy').then((d) => d.Route),
)
const CompareServicenowRoute = CompareServicenowRouteImport.update({
  id: '/compare/servicenow',
  path: '/compare/servicenow',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/compare/servicenow.lazy').then((d) => d.Route),
)
const CompareSailpointRoute = CompareSailpointRouteImport.update({
  id: '/compare/sailpoint',
  path: '/compare/sailpoint',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/compare/sailpoint.lazy').then((d) => d.Route),
)
const CompareQualysRoute = CompareQualysRouteImport.update({
  id: '/compare/qualys',
  path: '/compare/qualys',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/compare/qualys.lazy').then((d) => d.Route),
)
const CompareCrowdstrikeRoute = CompareCrowdstrikeRouteImport.update({
  id: '/compare/crowdstrike',
  path: '/compare/crowdstrike',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/compare/crowdstrike.lazy').then((d) => d.Route),
)
const CompareArcherRoute = CompareArcherRouteImport.update({
  id: '/compare/archer',
  path: '/compare/archer',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/compare/archer.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRoute
  '/auth': typeof AuthRouteWithChildren
  '/contact': typeof ContactRoute
  '/contact-2': typeof Contact2Route
  '/cookie-policy': typeof CookiePolicyRoute
  '/demo': typeof DemoRoute
  '/learn': typeof LearnRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/team': typeof TeamRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/compare/archer': typeof CompareArcherRoute
  '/compare/crowdstrike': typeof CompareCrowdstrikeRoute
  '/compare/qualys': typeof CompareQualysRoute
  '/compare/sailpoint': typeof CompareSailpointRoute
  '/compare/servicenow': typeof CompareServicenowRoute
  '/compare/splunk': typeof CompareSplunkRoute
  '/index/home': typeof IndexHomeRoute
  '/industries/education': typeof IndustriesEducationRoute
  '/industries/financial': typeof IndustriesFinancialRoute
  '/industries/government': typeof IndustriesGovernmentRoute
  '/industries/healthcare': typeof IndustriesHealthcareRoute
  '/industries/manufacturing': typeof IndustriesManufacturingRoute
  '/industries/mssp': typeof IndustriesMsspRoute
  '/industries/retail': typeof IndustriesRetailRoute
  '/platform/ai-agents': typeof PlatformAiAgentsRoute
  '/platform/business': typeof PlatformBusinessRoute
  '/platform/cmdb': typeof PlatformCmdbRoute
  '/platform/documents': typeof PlatformDocumentsRoute
  '/platform/grc': typeof PlatformGrcRoute
  '/platform/iam': typeof PlatformIamRoute
  '/platform/pentest': typeof PlatformPentestRoute
  '/platform/resilience': typeof PlatformResilienceRoute
  '/platform/service-desk': typeof PlatformServiceDeskRoute
  '/platform/xdr': typeof PlatformXdrRoute
  '/services/advisory': typeof ServicesAdvisoryRoute
  '/services/implementation': typeof ServicesImplementationRoute
  '/services/integration': typeof ServicesIntegrationRoute
  '/services/support': typeof ServicesSupportRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/compare/': typeof CompareIndexRoute
  '/industries/': typeof IndustriesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/app': typeof AppRoute
  '/auth': typeof AuthRouteWithChildren
  '/contact': typeof ContactRoute
  '/contact-2': typeof Contact2Route
  '/cookie-policy': typeof CookiePolicyRoute
  '/demo': typeof DemoRoute
  '/learn': typeof LearnRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/team': typeof TeamRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/compare/archer': typeof CompareArcherRoute
  '/compare/crowdstrike': typeof CompareCrowdstrikeRoute
  '/compare/qualys': typeof CompareQualysRoute
  '/compare/sailpoint': typeof CompareSailpointRoute
  '/compare/servicenow': typeof CompareServicenowRoute
  '/compare/splunk': typeof CompareSplunkRoute
  '/index/home': typeof IndexHomeRoute
  '/industries/education': typeof IndustriesEducationRoute
  '/industries/financial': typeof IndustriesFinancialRoute
  '/industries/government': typeof IndustriesGovernmentRoute
  '/industries/healthcare': typeof IndustriesHealthcareRoute
  '/industries/manufacturing': typeof IndustriesManufacturingRoute
  '/industries/mssp': typeof IndustriesMsspRoute
  '/industries/retail': typeof IndustriesRetailRoute
  '/platform/ai-agents': typeof PlatformAiAgentsRoute
  '/platform/business': typeof PlatformBusinessRoute
  '/platform/cmdb': typeof PlatformCmdbRoute
  '/platform/documents': typeof PlatformDocumentsRoute
  '/platform/grc': typeof PlatformGrcRoute
  '/platform/iam': typeof PlatformIamRoute
  '/platform/pentest': typeof PlatformPentestRoute
  '/platform/resilience': typeof PlatformResilienceRoute
  '/platform/service-desk': typeof PlatformServiceDeskRoute
  '/platform/xdr': typeof PlatformXdrRoute
  '/services/advisory': typeof ServicesAdvisoryRoute
  '/services/implementation': typeof ServicesImplementationRoute
  '/services/integration': typeof ServicesIntegrationRoute
  '/services/support': typeof ServicesSupportRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/compare': typeof CompareIndexRoute
  '/industries': typeof IndustriesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRoute
  '/auth': typeof AuthRouteWithChildren
  '/contact': typeof ContactRoute
  '/contact-2': typeof Contact2Route
  '/cookie-policy': typeof CookiePolicyRoute
  '/demo': typeof DemoRoute
  '/learn': typeof LearnRoute
  '/pricing': typeof PricingRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/security': typeof SecurityRoute
  '/team': typeof TeamRoute
  '/terms-of-service': typeof TermsOfServiceRoute
  '/compare/archer': typeof CompareArcherRoute
  '/compare/crowdstrike': typeof CompareCrowdstrikeRoute
  '/compare/qualys': typeof CompareQualysRoute
  '/compare/sailpoint': typeof CompareSailpointRoute
  '/compare/servicenow': typeof CompareServicenowRoute
  '/compare/splunk': typeof CompareSplunkRoute
  '/index/home': typeof IndexHomeRoute
  '/industries/education': typeof IndustriesEducationRoute
  '/industries/financial': typeof IndustriesFinancialRoute
  '/industries/government': typeof IndustriesGovernmentRoute
  '/industries/healthcare': typeof IndustriesHealthcareRoute
  '/industries/manufacturing': typeof IndustriesManufacturingRoute
  '/industries/mssp': typeof IndustriesMsspRoute
  '/industries/retail': typeof IndustriesRetailRoute
  '/platform/ai-agents': typeof PlatformAiAgentsRoute
  '/platform/business': typeof PlatformBusinessRoute
  '/platform/cmdb': typeof PlatformCmdbRoute
  '/platform/documents': typeof PlatformDocumentsRoute
  '/platform/grc': typeof PlatformGrcRoute
  '/platform/iam': typeof PlatformIamRoute
  '/platform/pentest': typeof PlatformPentestRoute
  '/platform/resilience': typeof PlatformResilienceRoute
  '/platform/service-desk': typeof PlatformServiceDeskRoute
  '/platform/xdr': typeof PlatformXdrRoute
  '/services/advisory': typeof ServicesAdvisoryRoute
  '/services/implementation': typeof ServicesImplementationRoute
  '/services/integration': typeof ServicesIntegrationRoute
  '/services/support': typeof ServicesSupportRoute
  '/auth/login': typeof AuthLoginLazyRoute
  '/auth/logout': typeof AuthLogoutLazyRoute
  '/compare/': typeof CompareIndexRoute
  '/industries/': typeof IndustriesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/auth'
    | '/contact'
    | '/contact-2'
    | '/cookie-policy'
    | '/demo'
    | '/learn'
    | '/pricing'
    | '/privacy-policy'
    | '/security'
    | '/team'
    | '/terms-of-service'
    | '/compare/archer'
    | '/compare/crowdstrike'
    | '/compare/qualys'
    | '/compare/sailpoint'
    | '/compare/servicenow'
    | '/compare/splunk'
    | '/index/home'
    | '/industries/education'
    | '/industries/financial'
    | '/industries/government'
    | '/industries/healthcare'
    | '/industries/manufacturing'
    | '/industries/mssp'
    | '/industries/retail'
    | '/platform/ai-agents'
    | '/platform/business'
    | '/platform/cmdb'
    | '/platform/documents'
    | '/platform/grc'
    | '/platform/iam'
    | '/platform/pentest'
    | '/platform/resilience'
    | '/platform/service-desk'
    | '/platform/xdr'
    | '/services/advisory'
    | '/services/implementation'
    | '/services/integration'
    | '/services/support'
    | '/auth/login'
    | '/auth/logout'
    | '/compare/'
    | '/industries/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/app'
    | '/auth'
    | '/contact'
    | '/contact-2'
    | '/cookie-policy'
    | '/demo'
    | '/learn'
    | '/pricing'
    | '/privacy-policy'
    | '/security'
    | '/team'
    | '/terms-of-service'
    | '/compare/archer'
    | '/compare/crowdstrike'
    | '/compare/qualys'
    | '/compare/sailpoint'
    | '/compare/servicenow'
    | '/compare/splunk'
    | '/index/home'
    | '/industries/education'
    | '/industries/financial'
    | '/industries/government'
    | '/industries/healthcare'
    | '/industries/manufacturing'
    | '/industries/mssp'
    | '/industries/retail'
    | '/platform/ai-agents'
    | '/platform/business'
    | '/platform/cmdb'
    | '/platform/documents'
    | '/platform/grc'
    | '/platform/iam'
    | '/platform/pentest'
    | '/platform/resilience'
    | '/platform/service-desk'
    | '/platform/xdr'
    | '/services/advisory'
    | '/services/implementation'
    | '/services/integration'
    | '/services/support'
    | '/auth/login'
    | '/auth/logout'
    | '/compare'
    | '/industries'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/auth'
    | '/contact'
    | '/contact-2'
    | '/cookie-policy'
    | '/demo'
    | '/learn'
    | '/pricing'
    | '/privacy-policy'
    | '/security'
    | '/team'
    | '/terms-of-service'
    | '/compare/archer'
    | '/compare/crowdstrike'
    | '/compare/qualys'
    | '/compare/sailpoint'
    | '/compare/servicenow'
    | '/compare/splunk'
    | '/index/home'
    | '/industries/education'
    | '/industries/financial'
    | '/industries/government'
    | '/industries/healthcare'
    | '/industries/manufacturing'
    | '/industries/mssp'
    | '/industries/retail'
    | '/platform/ai-agents'
    | '/platform/business'
    | '/platform/cmdb'
    | '/platform/documents'
    | '/platform/grc'
    | '/platform/iam'
    | '/platform/pentest'
    | '/platform/resilience'
    | '/platform/service-desk'
    | '/platform/xdr'
    | '/services/advisory'
    | '/services/implementation'
    | '/services/integration'
    | '/services/support'
    | '/auth/login'
    | '/auth/logout'
    | '/compare/'
    | '/industries/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRoute
  AuthRoute: typeof AuthRouteWithChildren
  ContactRoute: typeof ContactRoute
  Contact2Route: typeof Contact2Route
  CookiePolicyRoute: typeof CookiePolicyRoute
  DemoRoute: typeof DemoRoute
  LearnRoute: typeof LearnRoute
  PricingRoute: typeof PricingRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  SecurityRoute: typeof SecurityRoute
  TeamRoute: typeof TeamRoute
  TermsOfServiceRoute: typeof TermsOfServiceRoute
  CompareArcherRoute: typeof CompareArcherRoute
  CompareCrowdstrikeRoute: typeof CompareCrowdstrikeRoute
  CompareQualysRoute: typeof CompareQualysRoute
  CompareSailpointRoute: typeof CompareSailpointRoute
  CompareServicenowRoute: typeof CompareServicenowRoute
  CompareSplunkRoute: typeof CompareSplunkRoute
  IndexHomeRoute: typeof IndexHomeRoute
  IndustriesEducationRoute: typeof IndustriesEducationRoute
  IndustriesFinancialRoute: typeof IndustriesFinancialRoute
  IndustriesGovernmentRoute: typeof IndustriesGovernmentRoute
  IndustriesHealthcareRoute: typeof IndustriesHealthcareRoute
  IndustriesManufacturingRoute: typeof IndustriesManufacturingRoute
  IndustriesMsspRoute: typeof IndustriesMsspRoute
  IndustriesRetailRoute: typeof IndustriesRetailRoute
  PlatformAiAgentsRoute: typeof PlatformAiAgentsRoute
  PlatformBusinessRoute: typeof PlatformBusinessRoute
  PlatformCmdbRoute: typeof PlatformCmdbRoute
  PlatformDocumentsRoute: typeof PlatformDocumentsRoute
  PlatformGrcRoute: typeof PlatformGrcRoute
  PlatformIamRoute: typeof PlatformIamRoute
  PlatformPentestRoute: typeof PlatformPentestRoute
  PlatformResilienceRoute: typeof PlatformResilienceRoute
  PlatformServiceDeskRoute: typeof PlatformServiceDeskRoute
  PlatformXdrRoute: typeof PlatformXdrRoute
  ServicesAdvisoryRoute: typeof ServicesAdvisoryRoute
  ServicesImplementationRoute: typeof ServicesImplementationRoute
  ServicesIntegrationRoute: typeof ServicesIntegrationRoute
  ServicesSupportRoute: typeof ServicesSupportRoute
  CompareIndexRoute: typeof CompareIndexRoute
  IndustriesIndexRoute: typeof IndustriesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms-of-service': {
      id: '/terms-of-service'
      path: '/terms-of-service'
      fullPath: '/terms-of-service'
      preLoaderRoute: typeof TermsOfServiceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team': {
      id: '/team'
      path: '/team'
      fullPath: '/team'
      preLoaderRoute: typeof TeamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pricing': {
      id: '/pricing'
      path: '/pricing'
      fullPath: '/pricing'
      preLoaderRoute: typeof PricingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/learn': {
      id: '/learn'
      path: '/learn'
      fullPath: '/learn'
      preLoaderRoute: typeof LearnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cookie-policy': {
      id: '/cookie-policy'
      path: '/cookie-policy'
      fullPath: '/cookie-policy'
      preLoaderRoute: typeof CookiePolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact-2': {
      id: '/contact-2'
      path: '/contact-2'
      fullPath: '/contact-2'
      preLoaderRoute: typeof Contact2RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/': {
      id: '/industries/'
      path: '/industries'
      fullPath: '/industries/'
      preLoaderRoute: typeof IndustriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/': {
      id: '/compare/'
      path: '/compare'
      fullPath: '/compare/'
      preLoaderRoute: typeof CompareIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/logout': {
      id: '/auth/logout'
      path: '/logout'
      fullPath: '/auth/logout'
      preLoaderRoute: typeof AuthLogoutLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginLazyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/services/support': {
      id: '/services/support'
      path: '/services/support'
      fullPath: '/services/support'
      preLoaderRoute: typeof ServicesSupportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/integration': {
      id: '/services/integration'
      path: '/services/integration'
      fullPath: '/services/integration'
      preLoaderRoute: typeof ServicesIntegrationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/implementation': {
      id: '/services/implementation'
      path: '/services/implementation'
      fullPath: '/services/implementation'
      preLoaderRoute: typeof ServicesImplementationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/services/advisory': {
      id: '/services/advisory'
      path: '/services/advisory'
      fullPath: '/services/advisory'
      preLoaderRoute: typeof ServicesAdvisoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/xdr': {
      id: '/platform/xdr'
      path: '/platform/xdr'
      fullPath: '/platform/xdr'
      preLoaderRoute: typeof PlatformXdrRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/service-desk': {
      id: '/platform/service-desk'
      path: '/platform/service-desk'
      fullPath: '/platform/service-desk'
      preLoaderRoute: typeof PlatformServiceDeskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/resilience': {
      id: '/platform/resilience'
      path: '/platform/resilience'
      fullPath: '/platform/resilience'
      preLoaderRoute: typeof PlatformResilienceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/pentest': {
      id: '/platform/pentest'
      path: '/platform/pentest'
      fullPath: '/platform/pentest'
      preLoaderRoute: typeof PlatformPentestRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/iam': {
      id: '/platform/iam'
      path: '/platform/iam'
      fullPath: '/platform/iam'
      preLoaderRoute: typeof PlatformIamRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/grc': {
      id: '/platform/grc'
      path: '/platform/grc'
      fullPath: '/platform/grc'
      preLoaderRoute: typeof PlatformGrcRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/documents': {
      id: '/platform/documents'
      path: '/platform/documents'
      fullPath: '/platform/documents'
      preLoaderRoute: typeof PlatformDocumentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/cmdb': {
      id: '/platform/cmdb'
      path: '/platform/cmdb'
      fullPath: '/platform/cmdb'
      preLoaderRoute: typeof PlatformCmdbRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/business': {
      id: '/platform/business'
      path: '/platform/business'
      fullPath: '/platform/business'
      preLoaderRoute: typeof PlatformBusinessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/platform/ai-agents': {
      id: '/platform/ai-agents'
      path: '/platform/ai-agents'
      fullPath: '/platform/ai-agents'
      preLoaderRoute: typeof PlatformAiAgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/retail': {
      id: '/industries/retail'
      path: '/industries/retail'
      fullPath: '/industries/retail'
      preLoaderRoute: typeof IndustriesRetailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/mssp': {
      id: '/industries/mssp'
      path: '/industries/mssp'
      fullPath: '/industries/mssp'
      preLoaderRoute: typeof IndustriesMsspRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/manufacturing': {
      id: '/industries/manufacturing'
      path: '/industries/manufacturing'
      fullPath: '/industries/manufacturing'
      preLoaderRoute: typeof IndustriesManufacturingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/healthcare': {
      id: '/industries/healthcare'
      path: '/industries/healthcare'
      fullPath: '/industries/healthcare'
      preLoaderRoute: typeof IndustriesHealthcareRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/government': {
      id: '/industries/government'
      path: '/industries/government'
      fullPath: '/industries/government'
      preLoaderRoute: typeof IndustriesGovernmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/financial': {
      id: '/industries/financial'
      path: '/industries/financial'
      fullPath: '/industries/financial'
      preLoaderRoute: typeof IndustriesFinancialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/industries/education': {
      id: '/industries/education'
      path: '/industries/education'
      fullPath: '/industries/education'
      preLoaderRoute: typeof IndustriesEducationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/index/home': {
      id: '/index/home'
      path: '/index/home'
      fullPath: '/index/home'
      preLoaderRoute: typeof IndexHomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/splunk': {
      id: '/compare/splunk'
      path: '/compare/splunk'
      fullPath: '/compare/splunk'
      preLoaderRoute: typeof CompareSplunkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/servicenow': {
      id: '/compare/servicenow'
      path: '/compare/servicenow'
      fullPath: '/compare/servicenow'
      preLoaderRoute: typeof CompareServicenowRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/sailpoint': {
      id: '/compare/sailpoint'
      path: '/compare/sailpoint'
      fullPath: '/compare/sailpoint'
      preLoaderRoute: typeof CompareSailpointRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/qualys': {
      id: '/compare/qualys'
      path: '/compare/qualys'
      fullPath: '/compare/qualys'
      preLoaderRoute: typeof CompareQualysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/crowdstrike': {
      id: '/compare/crowdstrike'
      path: '/compare/crowdstrike'
      fullPath: '/compare/crowdstrike'
      preLoaderRoute: typeof CompareCrowdstrikeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/compare/archer': {
      id: '/compare/archer'
      path: '/compare/archer'
      fullPath: '/compare/archer'
      preLoaderRoute: typeof CompareArcherRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthRouteChildren {
  AuthLoginLazyRoute: typeof AuthLoginLazyRoute
  AuthLogoutLazyRoute: typeof AuthLogoutLazyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthLoginLazyRoute: AuthLoginLazyRoute,
  AuthLogoutLazyRoute: AuthLogoutLazyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRoute,
  AuthRoute: AuthRouteWithChildren,
  ContactRoute: ContactRoute,
  Contact2Route: Contact2Route,
  CookiePolicyRoute: CookiePolicyRoute,
  DemoRoute: DemoRoute,
  LearnRoute: LearnRoute,
  PricingRoute: PricingRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  SecurityRoute: SecurityRoute,
  TeamRoute: TeamRoute,
  TermsOfServiceRoute: TermsOfServiceRoute,
  CompareArcherRoute: CompareArcherRoute,
  CompareCrowdstrikeRoute: CompareCrowdstrikeRoute,
  CompareQualysRoute: CompareQualysRoute,
  CompareSailpointRoute: CompareSailpointRoute,
  CompareServicenowRoute: CompareServicenowRoute,
  CompareSplunkRoute: CompareSplunkRoute,
  IndexHomeRoute: IndexHomeRoute,
  IndustriesEducationRoute: IndustriesEducationRoute,
  IndustriesFinancialRoute: IndustriesFinancialRoute,
  IndustriesGovernmentRoute: IndustriesGovernmentRoute,
  IndustriesHealthcareRoute: IndustriesHealthcareRoute,
  IndustriesManufacturingRoute: IndustriesManufacturingRoute,
  IndustriesMsspRoute: IndustriesMsspRoute,
  IndustriesRetailRoute: IndustriesRetailRoute,
  PlatformAiAgentsRoute: PlatformAiAgentsRoute,
  PlatformBusinessRoute: PlatformBusinessRoute,
  PlatformCmdbRoute: PlatformCmdbRoute,
  PlatformDocumentsRoute: PlatformDocumentsRoute,
  PlatformGrcRoute: PlatformGrcRoute,
  PlatformIamRoute: PlatformIamRoute,
  PlatformPentestRoute: PlatformPentestRoute,
  PlatformResilienceRoute: PlatformResilienceRoute,
  PlatformServiceDeskRoute: PlatformServiceDeskRoute,
  PlatformXdrRoute: PlatformXdrRoute,
  ServicesAdvisoryRoute: ServicesAdvisoryRoute,
  ServicesImplementationRoute: ServicesImplementationRoute,
  ServicesIntegrationRoute: ServicesIntegrationRoute,
  ServicesSupportRoute: ServicesSupportRoute,
  CompareIndexRoute: CompareIndexRoute,
  IndustriesIndexRoute: IndustriesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
